export default __webpack_public_path__ + "static/Ship correctly-fa4e25571c586da9eca33fda7595456e.png";